import { useUserProvider } from '@wt/game/providers/user/UserProvider';
import Link from 'next/link';

// Slim gold "Remove ads" tab hanging off the right edge of the banner ad.
// It has to match the collapse button's height exactly (h-4 / 16px) so it
// reads as part of the same tab strip rather than a full-size CTA — that's
// too little room for the bolder gold-button treatment used elsewhere on
// our sites, so this gets its own compact style.
export const RemoveAdsBannerTab = ({ top }: { top: string }) => {
  const { user } = useUserProvider();

  if (user.isPremium) return null;

  return (
    <Link
      href="/passport"
      className={`remove-ads-tab absolute right-0 ${top} flex h-4 shrink items-center overflow-hidden whitespace-nowrap rounded-bl-md rounded-br-md px-2 text-[9px] font-bold uppercase leading-none tracking-wide text-[#3a2500] md:text-[10px]`}
      style={{
        background:
          'linear-gradient(135deg, #ffe7a3 0%, #f5c94f 52%, #d9a521 100%)',
      }}
      aria-label="Remove ads"
    >
      Remove ads
    </Link>
  );
};
